import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Form, } from 'reactstrap';
import { pick, mapValues, } from 'lodash';
import { Link } from 'react-router-dom';
import { useToggle } from 'react-use';
import qs from 'qs';
import { PDFDocument, rgb } from 'pdf-lib';
import fileDownload from 'js-file-download';
import jsbarcode from 'jsbarcode';
import { jsPDF } from "jspdf";

import firebase from '../../firebase';
import { batch } from '../../shared/firebase';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import ProgressButton from '../ProgressButton';
import { fields } from '../../shared/models/user';

const { keys, entries } = Object;
const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const shippingRequestsCsvInfoRef = db.collection('settings').doc('shippingRequestsCsvInfo');

export default function ShippingRequestCsvFlowModal(props) {
  const { shippingRequestsCsvInfo } = props;
  const onClickProcessed = async () => {
    await shippingRequestsCsvInfoRef.update({
      status: 'processed',
    });
  };
  const onClickGoToPickingList = async () => {
    await shippingRequestsCsvInfoRef.update({
      status: 'went',
    });
    const shippingRequests = await Promise.all(shippingRequestsCsvInfo.ids.map(async ({ tenantId, shippingRequestId, }) => {
      const doc = await tenantsRef.doc(tenantId).collection('shippingRequests').doc(shippingRequestId).get();
      return { tenantId, id: shippingRequestId, ...doc.data() };
    }));
    const files = shippingRequests.map(shippingRequest => (shippingRequest.files || []).map(_ => ({ ..._, shippingRequest }))).flat();
    if(files.length > 0) {
      const allPdfDoc = await PDFDocument.create();
      await files.reduce(async (x, file) => {
        await x;

        const { shippingRequest: { id, tenantId }, } = file;
        const res = await fetch(file.downloadUrl);
        const pdfBytes = await res.arrayBuffer();
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const pages = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
        await pages.reduce(async (x, page) => {
          await x;
          const { width, height } = page.getSize();
          const text = [tenantId, id].join('-');
          page.drawText(text, {
            x: width - (30 + text.length * 6),
            y: height - 35,
            size: 10,
          })
          await allPdfDoc.addPage(page);
        }, Promise.resolve());
      }, Promise.resolve());
      const content = await allPdfDoc.save()
      const blob = new Blob([content], { type: 'application/pdf' });
      window.open(URL.createObjectURL(blob));
    }
  };
  const onClickPrinted = async () => {
    await shippingRequestsCsvInfoRef.update({
      status: 'completed',
    });
  };
  const onClickClose = async () => {
    if(!window.confirm('本当に閉じますか？')) return;

    await batch(db, shippingRequestsCsvInfo.ids, (batch, { tenantId, shippingRequestId }) => {
      batch.update(tenantsRef.doc(tenantId).collection('shippingRequests').doc(shippingRequestId), { status: 'waitingToShip', processStartedAt: null, });
    });
    await shippingRequestsCsvInfoRef.update({
      status: 'closed',
    });
    await props.onCancel();
  };

  return (
    <Modal isOpen>
      <ModalHeader>
        ステップに沿って作業してください
      </ModalHeader>
      <ModalBody>
        <Button color="secondary" onClick={onClickProcessed} disabled={shippingRequestsCsvInfo.status !== 'downloaded'}>
          {
            ['downloaded'].includes(shippingRequestsCsvInfo.status) ? (
              <span className="mr-1">1.</span>
            ) : (
              <span className="fas fa-check text-success mr-1" />
            )
          }
          ダウンロードしたCSVの伝票を発行、印刷した
        </Button>
        <Button className="mt-3" color="secondary" tag={Link} target="_blank" to={`/admin/shippingRequestsPickingList`} onClick={onClickGoToPickingList} disabled={shippingRequestsCsvInfo.status === 'downloaded'}>
          {
            ['downloaded', 'processed'].includes(shippingRequestsCsvInfo.status) ? (
              <span className="mr-1">2.</span>
            ) : (
              <span className="fas fa-check text-success mr-1" />
            )
          }
          ピッキングリスト、添付ファイルを表示する
        </Button>
        <Button className="mt-3" color="secondary" onClick={onClickPrinted} disabled={shippingRequestsCsvInfo.status !== 'went'}>
          {
            ['downloaded', 'processed', 'went'].includes(shippingRequestsCsvInfo.status) ? (
              <span className="mr-1">3.</span>
            ) : (
              <span className="fas fa-check text-success mr-1" />
            )
          }
          ピッキングリスト、添付ファイルを印刷した
        </Button>
      </ModalBody>
      <ModalFooter>
        <ProgressButton className="cancel" color="danger" process={onClickClose}>誤ってダウンロードボタンを押したので閉じる</ProgressButton>
      </ModalFooter>
    </Modal>
  );
};
